import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isLoading)?_c(VSkeletonLoader,{attrs:{"loading":"","type":"article, actions"}}):_c('div',{ref:"container",staticClass:"google-maps-container"})
}
var staticRenderFns = []

export { render, staticRenderFns }